module.exports = __webpack_public_path__ + "img/icon-dollar-white.8234da0a.svg";